(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4583],{

/***/ 60639:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics",
      function () {
        return __webpack_require__(40354);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14141);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50056);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15313);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_auth_switch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17343);
/* harmony import */ var components_warning_notification__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42805);
/* harmony import */ var components_analytics_panoramic__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81858);
/* harmony import */ var theme_header__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28116);
/* harmony import */ var theme_layouts_body__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89129);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5799);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99408);
/* harmony import */ var components_top_bar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32095);
/* harmony import */ var _components_analytics_analytics_sub_menu__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(58562);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        "px ",
        "px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





 // Next.js router









var StyledWarningNotification = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)(components_warning_notification__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-12237080-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_3__/* .themeGet */ .R)("space.l"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_3__/* .themeGet */ .R)("space.l"));
function AnalyticPage() {
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(); // Ottieni il router di Next.js
    // Ottieni il valore di dataType dalla query string
    var dataType = router.query.dataType;
    // Determina l'activeKey in base a dataType
    var activeKey = !dataType || dataType === "aggregated_data" || dataType === "temporary_data" ? "panoramic" : "confirmed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_auth_switch__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_top_bar__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_layouts_body__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                bg: "primary_50",
                height: "100%"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_header__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                bg: "white",
                title: "StreetLib Analytics",
                style: {
                    bg: "white",
                    borderWidth: "0",
                    borderBottomWidth: "1px",
                    borderColor: "primary_200",
                    borderStyle: "solid"
                },
                componentLeft: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    ml: [
                        0,
                        "l",
                        "l",
                        "l"
                    ],
                    fontSize: [
                        "h3",
                        "h2",
                        "h2",
                        "h2"
                    ],
                    lineHeight: [
                        "h3",
                        "h2",
                        "h2",
                        "h2"
                    ],
                    fontWeight: "bold",
                    color: "grey_600",
                    textAlign: "left",
                    children: translations__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z[languageCode].analytics
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_analytics_analytics_sub_menu__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                activeKey: activeKey
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWarningNotification, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_analytics_panoramic__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (AnalyticPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5937,3092,1664,8098,8446,4064,280,4762,1354,9253,7624,6346,3333,9084,5354,6535,7343,2544,5743,3063,3620,6770,1219,1858,9774,2888,179], function() { return __webpack_exec__(60639); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);